import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" id="pricing" data-id="element-148">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-150">
          ELEGÍ TU OPCIÓN
        </h2>
        <div className="w-24 h-1 bg-gold-gradient mx-auto rounded-full" data-id="element-151" />
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mb-16" data-id="element-152">
        {/* PACK BASE */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0f1d36] border border-[#1a2b4c] rounded-3xl p-8 order-2 lg:order-1" data-id="element-153">
          <div className="mb-8" data-id="element-154">
            <h3 className="text-2xl font-bold text-white font-heading mb-2" data-id="element-155">
              📘 PACK BASE
            </h3>
            <div className="flex items-baseline gap-2 mb-4" data-id="element-156">
              <span className="text-4xl font-bold text-white" data-id="element-157">$19.990</span>
              <span className="text-[#a0aec0]" data-id="element-158">ARS</span>
            </div>
          </div>

          <ul className="space-y-4 mb-8" data-id="element-159">
            <li className="flex items-center gap-3" data-id="element-160">
              <Check className="w-5 h-5 text-green-400 shrink-0" data-id="element-161" />
              <span className="text-[#e2e8f0]" data-id="element-162">8 Módulos Profesionales</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-163">
              <Check className="w-5 h-5 text-green-400 shrink-0" data-id="element-164" />
              <span className="text-[#e2e8f0]" data-id="element-165">4 Bonos Exclusivos</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-166">
              <Check className="w-5 h-5 text-green-400 shrink-0" data-id="element-167" />
              <span className="text-[#e2e8f0]" data-id="element-168">115 páginas PDF</span>
            </li>
            <li className="flex items-center gap-3 opacity-50" data-id="element-169">
              <X className="w-5 h-5 text-red-400 shrink-0" data-id="element-170" />
              <span className="text-[#a0aec0] line-through" data-id="element-171">
                El Cerebro Clínico del AT
              </span>
            </li>
          </ul>

          <a href="https://fegion.shop/cart/46278540918923:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 text-center text-[#a0aec0] border border-[#1a2b4c] rounded-xl hover:bg-[#1a2b4c]/50 transition-colors font-medium" data-id="element-172">
            No gracias, prefiero solo el Pack Base
          </a>
        </motion.div>

        {/* COMBO ELITE */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0a1628] border-2 border-[#d4af37] rounded-3xl p-8 relative gold-glow-strong order-1 lg:order-2 transform lg:scale-105 z-10" data-id="element-173">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-[#0a1628] font-bold px-6 py-1 rounded-full text-sm tracking-wide whitespace-nowrap" data-id="element-174">
            MÁS ELEGIDO — AHORRAS $9.990
          </div>

          <div className="mb-8 mt-4 text-center" data-id="element-175">
            <h3 className="text-3xl font-bold text-white font-heading mb-2" data-id="element-176">
              🏆 COMBO ELITE
            </h3>
            <div className="text-[#a0aec0] line-through mb-1" data-id="element-177">
              Valor real: $39.980
            </div>
            <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-178">
              <span className="text-5xl font-bold text-gold-gradient" data-id="element-179">
                HOY: $29.990
              </span>
              <span className="text-[#d4af37]" data-id="element-180">ARS</span>
            </div>
          </div>

          <ul className="space-y-4 mb-8" data-id="element-181">
            {['8 Módulos Profesionales', '4 Bonos Exclusivos', 'El Cerebro Clínico del AT', 'El Traductor de Clínica', 'Hojas de Ruta 30 Días', 'Protocolo Legal de Cobro', 'Crisis Nivel 2', 'Vademécum del AT', '168 páginas PDF totales', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-182">
                <Check className="w-5 h-5 text-[#d4af37] shrink-0" data-id="element-183" />
                <span className="text-white font-medium" data-id="element-184">{item}</span>
              </li>)}
          </ul>

          <motion.a href="https://fegion.shop/cart/46278545768587:1" target="_blank" rel="noopener noreferrer" animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} className="group relative flex items-center justify-center gap-2 w-full py-5 px-6 bg-[#FFD700] text-[#0a1628] rounded-xl font-bold text-lg hover:brightness-110 transition-all overflow-hidden" data-id="element-185">
            <span className="absolute inset-0 w-full h-full bg-white/30 group-hover:translate-x-full -translate-x-full transition-transform duration-500 ease-out skew-x-12" data-id="element-186" />
            → SÍ, QUIERO EL COMBO ELITE ←
          </motion.a>

          <div className="mt-6 flex justify-center gap-4 text-sm text-[#a0aec0]" data-id="element-187">
            <span className="flex items-center gap-1" data-id="element-188">
              <Check className="w-4 h-4 text-green-400" data-id="element-189" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-190">
              <Check className="w-4 h-4 text-green-400" data-id="element-191" /> Pago seguro
            </span>
          </div>
        </motion.div>
      </div>

      {/* Comparison Table */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="max-w-3xl mx-auto" data-id="element-192">
        <h4 className="text-center text-xl text-white font-bold mb-6" data-id="element-193">
          COMPARATIVA COMPLETA
        </h4>
        <div className="bg-[#0f1d36] rounded-2xl border border-[#1a2b4c] overflow-hidden" data-id="element-194">
          <div className="grid grid-cols-3 bg-[#0a1628] border-b border-[#1a2b4c] p-4" data-id="element-195">
            <div data-id="element-196"></div>
            <div className="text-center font-bold text-[#a0aec0]" data-id="element-197">BASE</div>
            <div className="text-center font-bold text-[#d4af37]" data-id="element-198">ELITE</div>
          </div>
          <div className="divide-y divide-[#1a2b4c]" data-id="element-199">
            {[{
            label: '8 Módulos',
            base: true,
            elite: true
          }, {
            label: '4 Bonos',
            base: true,
            elite: true
          }, {
            label: 'El Traductor',
            base: false,
            elite: true
          }, {
            label: 'Hojas de Ruta',
            base: false,
            elite: true
          }, {
            label: 'Protocolo Legal',
            base: false,
            elite: true
          }, {
            label: 'Crisis Nivel 2',
            base: false,
            elite: true
          }, {
            label: 'Vademécum AT',
            base: false,
            elite: true
          }, {
            label: 'Precio',
            base: '$19.990',
            elite: '$29.990'
          }].map((row, i) => <div key={i} className="grid grid-cols-3 p-4 hover:bg-[#1a2b4c]/30 transition-colors" data-id="element-200">
                <div className="text-[#e2e8f0] font-medium" data-id="element-201">{row.label}</div>
                <div className="text-center flex justify-center items-center" data-id="element-202">
                  {typeof row.base === 'boolean' ? row.base ? <Check className="w-5 h-5 text-green-400" data-id="element-203" /> : <X className="w-5 h-5 text-red-400 opacity-50" data-id="element-204" /> : <span className="text-[#a0aec0]" data-id="element-205">{row.base}</span>}
                </div>
                <div className="text-center flex justify-center items-center" data-id="element-206">
                  {typeof row.elite === 'boolean' ? row.elite ? <Check className="w-5 h-5 text-[#d4af37]" data-id="element-207" /> : <X className="w-5 h-5 text-red-400" data-id="element-208" /> : <span className="text-[#d4af37] font-bold" data-id="element-209">
                      {row.elite}
                    </span>}
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-8 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-xl p-6 text-center" data-id="element-210">
          <p className="text-xl text-white font-medium mb-2" data-id="element-211">
            💡 Solo{' '}
            <span className="text-[#d4af37] font-bold" data-id="element-212">$10.000 ARS</span> más.
          </p>
          <p className="text-[#e2e8f0]" data-id="element-213">
            El Cerebro Clínico del AT por separado vale $19.990 ARS.
          </p>
          <p className="text-[#e2e8f0]" data-id="element-214">
            Agregándolo ahora lo llevás a la mitad del precio.
          </p>
        </div>
      </motion.div>
    </section>;
}